import gql from "graphql-tag";

export const GET_SERVICE_CATEGORY_BY_ID = gql`
query getServiceCategoryById($id: uuid!){
  ServiceCategories(where: { id: {_eq: $id}}){
    id
    name
    image
    description
    createdBy
  }
}`

export const GET_SERVICE_CATEGORIES = gql`
query getServiceCategories{
  serviceCategories: ServiceCategories{
    id
    name   
  }
}`